import { Component, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfig } from 'src/app/app.config';
import { NavDropdownComponent } from '../ui-components/nav-dropdown/nav-dropdown.component';
import { Menu } from '../utils/menu';
import { Routes } from '../utils/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const navbar = document.querySelector('nav');
    if (navbar) {
      this.isSticky = navbar.classList.contains('sticky-top');

      // Add scrolled class for transparent navbar transition
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.isScrolled = scrollPosition > 100;

      if (this.isScrolled) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    }
  }

  @HostListener('window:resize', [])
  onWindowResize() {
    this.isLargeScreen = window.innerWidth > 1024;
  }

  industriesMenu: Menu[] = [];
  productsMenu: Menu[] = [];
  servicesMenu: Menu[] = [];
  africaWeather_url: string='';
  isSticky: boolean = false;
  isScrolled: boolean = false;
  isLargeScreen: boolean = window.innerWidth > 1024;
  mobileNavOpen: boolean = false;

  constructor(private router: Router,private deviceService: DeviceDetectorService, private route:Routes,private config:AppConfig) {
  }
  ngOnInit(): void {
    this.productsMenu= this.route.productsMenu;
    this.industriesMenu = this.route.industriesMenu;
    this.servicesMenu = this.route.servicesMenu;
    this.africaWeather_url= this.config.AFRICAWEATHER_PORTAL_WEB;
  }

  onNavigate() {
    window.open(this.africaWeather_url, "_blank");
  }
  toggleMobileNav() {
    this.mobileNavOpen = !this.mobileNavOpen;
    document.body.classList.toggle('overflow-hidden', this.mobileNavOpen);
  }

  closeMenu() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();


    if (isMobile || isTablet) {
      const btnBar = document.getElementById('barMenuId');
      if (btnBar) {
        btnBar.click();
      }
    }
  }
  closeNav() {
    if(this.isMobile() || this.isTablet()){
    this.mobileNavOpen = !this.mobileNavOpen;
    document.body.classList.toggle('overflow-hidden', this.mobileNavOpen);
    }
  }

  get logoSrc(): string {
    // Show white logo on desktop when at top (transparent navbar)
    // Show black logo on mobile/tablet or when scrolled
    const logoColor = (!this.isLargeScreen || (this.isLargeScreen && this.isScrolled)) ? 'black' : 'white';
    return `assets/images/logos/weblogo${logoColor}.png`;
  }

  isMobile(){
    return window.innerWidth <= 768;
  }
  isTablet(){
    return window.innerWidth > 768 && window.innerWidth <= 1024;
  }

  @ViewChildren(NavDropdownComponent) navDropdowns!: QueryList<NavDropdownComponent>;

  onDropdownOpened(openedDropdown: NavDropdownComponent) {
    if (this.isMobile() || this.isTablet()) {
      this.navDropdowns.forEach(dropdown => {
        if (dropdown !== openedDropdown) {
          // Close other dropdowns without emitting closeBarMenu (to avoid closing the drawer)
          // accessing the private/public property directly or using a method that doesn't emit closeBarMenu?
          // The current closeMenu() emits closeBarMenu().
          // Use a new method 'collapse()' on child? Or just set isOpen = false?
          // Actually, closeMenu() emitting closeBarMenu might close the whole sidebar if that's what it does.
          // Let's check closeMenu in NavDropdown.
          // It calls closeBarMenu.emit().
          // And Navbar listens to (closeBarMenu)="closeNav()".
          // closeNav() toggles mobileNavOpen.
          // So if we call closeMenu() on a sibling, it will close the entire sidebar. BAD.

          // We need to just collapse the menu.
          dropdown.isOpen = false;
        }
      });
    }
  }
}
